export default {
    CUSTOM_FIELD_TYPES: {
        MULTISELECT: 'MultiSelect',
        CURRENCY: 'Currency',
        DATE: 'Date',
        DATETIME: 'DateTime',
        DAY_OF_WEEK: 'DayOfWeek',
        DECIMAL_NUMBER: 'NumberDecimal',
        SELECT: 'Select',
        SELECT1: 'select',
        OPTION: 'option',
        SSN: 'SSN',
        DRILLDOWN: 'Drilldown',
        EMAIL: 'Email',
        MONTH: 'Month',
        NAME: 'Name',
        PERCENT: 'Percent',
        PHONE_NUMBER: 'Phone',
        RADIO: 'Radio',
        RADIOS: 'radio',
        STATE: 'State',
        TEXT: 'text',
        TEXTS: 'Text',
        TEXT_AREA: 'TextArea',
        WEBSITE: 'Website',
        WHOLE_NUMBER: 'Number',
        USER: 'User',
        USER_MULTISELECT: 'UserMultiSelect',
        YEAR: 'Year',
        YES_NO: 'YesNo',
        CHECKBOX: 'checkbox',
        HEADER: 'header',
        IMAGE: 'image',
        LOGO: 'logo',
        PARAGRAPH: 'paragraph',
        PASSWORD: 'password',
    },
};
